export async function copyAsyncResponseToClipboard(promise: () => Promise<string>): Promise<void> {
  if (typeof ClipboardItem === "undefined") {
    const string = await promise()
    await navigator.clipboard.writeText(string)
  } else {
    // workaround for Safari : https://stackoverflow.com/a/68241516
    const text = new ClipboardItem({
      "text/plain": promise().then(string => new Blob([string], { type: "text/plain" })),
    })
    await navigator.clipboard.write([text])
  }
}
